import AntdRow from "antd/es/row";

const Row = AntdRow;

export { Row };
